import { type PayinOrder } from '~/entities/payin';
import { type OrderOrigin } from '~/shared/lib/orderRoutes';
import { type TableData } from '~/shared/ui/Table';
import { orderTableHeaders } from './columns';
import { prepareTableRows } from './prepareTableRows';

interface PrepareTableDataProps {
    orders?: PayinOrder[];
    origin: OrderOrigin;
}

export const prepareTableData = ({ orders, origin }: PrepareTableDataProps): TableData<PayinOrder> => {
    return {
        head: orderTableHeaders,
        rows: prepareTableRows({ orders, origin }),
        caption: orders?.length === 0 ? 'Ордеров нет' : undefined,
    };
};
